import { useContext, useState } from "react"
import _ from "lodash"
import { api } from "../../api/api"
import { DateTime } from "luxon"
import { ModalDeliveryDistrict } from "../../components/Modals/DeliveryDistrict"
import { Toast } from "../../utils/Toast"
import { DistrictContext } from "../../context/DistrictContext"
import { mascaraMoeda, maskCurrency } from "../../utils/utils"
import { FiChevronDown, FiChevronUp, FiMapPin, FiPlus, FiSearch } from "react-icons/fi"
import { GlobalContext } from "../../context/GlobalContext"

export function DeliveryDistrictPage() {
  const { isAccess } = useContext(GlobalContext)

  const { findAll, deliveryDistrict, setDeliveryDistrict } = useContext(DistrictContext)
  const [search, setSearch] = useState('')
  const [timer, setTimer] = useState(null)
  const [orderBy, setOrderby] = useState({
    field: null,
    order: null
  })

  function sortBy(field) {
    const order = orderBy.field === field && orderBy.order === 'asc' ? 'desc' : 'asc'
    setDeliveryDistrict((districts) => _.orderBy(districts, (item) => item[field], order))
    setOrderby({ field, order })
  }

  async function saveUpdate(id, key, valueInput) {
    try {
      await api.put('/delivery-district/' + id, {
        [key]: valueInput
      })
      Toast.success("Registro atualizado com sucesso.")
    } catch (error) {
      await findAll()
      const message = error.response?.data
      if (typeof message === 'string' && message.includes('Esse bairro já está cadastrado.')) {
        return Toast.warning('Esse bairro já está cadastrado.')
      }
      Toast.warning()
    }
  }

  async function updated(id, key, valueInput) {
    if (!isAccess('metodo_entrega', 'update')) {
      return Toast.warning('Você não tem permissão para atualizar entrega.')
    }

    setDeliveryDistrict((districts) => districts.map((e) => e.id === id ? { ...e, [key]: valueInput } : { ...e }))

    if (typeof valueInput === 'boolean') {
      return saveUpdate(id, key, valueInput)
    }

    clearTimeout(timer)

    const newTimer = setTimeout(() => {
      saveUpdate(id, key, valueInput)
    }, 800)

    setTimer(newTimer)
  }

  return (
    <>
      <ModalDeliveryDistrict />
      <div className="district-panel">
        <div className="district-panel-header">
          <div><span><FiMapPin size={17} /></span><div><h3>Bairros e taxas</h3><p>{deliveryDistrict.length} {deliveryDistrict.length === 1 ? 'bairro cadastrado' : 'bairros cadastrados'}</p></div></div>
          <button type="button" data-bs-toggle="modal" data-bs-target="#modalDeliveryDistrict"><FiPlus size={16} /> Adicionar bairro</button>
        </div>

        <div className="district-toolbar">
          <div className="district-search">
            <FiSearch size={16} />
            <input type="search" placeholder="Pesquisar bairro..." value={search} onChange={(event) => setSearch(event.target.value)} onKeyDown={(event) => event.key === 'Enter' && findAll(search)} />
            <button type="button" onClick={() => findAll(search)}>Pesquisar</button>
          </div>
        </div>

        <div className="district-table-wrap">
              <table className="district-table">
                <thead>
                  <tr>
                    <th onClick={() => sortBy('district')}>
                      Bairro {orderBy.field === 'district' && (orderBy.order === 'asc' ? <FiChevronDown /> : <FiChevronUp />)}
                    </th>
                    <th onClick={() => sortBy('pricing')}>
                      Taxa {orderBy.field === 'pricing' && (orderBy.order === 'asc' ? <FiChevronDown /> : <FiChevronUp />)}
                    </th>
                    <th >Frete Grátis</th>
                    <th >Ativo</th>
                    <th >Criado</th>
                    <th >Atualizado</th>
                  </tr>
                </thead>
                <tbody>
                  {deliveryDistrict.map((item) => {
                    return (
                      <tr key={item.id}>
                        <td data-label="Bairro">
                          <input
                            type="text"
                            aria-label="Nome do bairro"
                            value={item.district}
                            onChange={(e) => updated(item.id, 'district', e.target.value)}
                          />
                        </td>
                        <td data-label="Taxa">
                          <input
                            type="text"
                            aria-label="Taxa de entrega"
                            value={maskCurrency(item.pricing)}
                            onChange={(e) => updated(item.id, 'pricing', mascaraMoeda(e.target.value))}
                          />
                        </td>
                        <td data-label="Frete grátis">
                          <label className="district-switch">
                            <input
                              type="checkbox"
                              checked={item.free}
                              onChange={(e) => updated(item.id, 'free', e.target.checked)}
                              role="switch"
                              aria-label={`Frete grátis para ${item.district}`}
                            />
                            <span />
                          </label>
                        </td>
                        <td data-label="Ativo">
                          <label className="district-switch">
                            <input
                              type="checkbox"
                              checked={item.active}
                              onChange={(e) => updated(item.id, 'active', e.target.checked)}
                              role="switch"
                              aria-label={`Ativar ${item.district}`}
                            />
                            <span />
                          </label>
                        </td>
                        <td data-label="Criado">{DateTime.fromISO(item.createdAt).toFormat("dd/MM/yyyy HH:mm")}</td>
                        <td data-label="Atualizado">{DateTime.fromISO(item.updatedAt).toFormat("dd/MM/yyyy HH:mm")}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
              {deliveryDistrict.length === 0 && <div className="district-empty"><FiMapPin size={24} /><strong>Nenhum bairro cadastrado</strong><span>Adicione um bairro para configurar sua taxa.</span></div>}
        </div>
      </div>
    </>
  )
}
